/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import GlobalModel from 'echarts/lib/model/Global';
import ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import ThemeRiverSeriesModel from 'echarts/lib/chart/themeRiver/ThemeRiverSeries';
import { linePolygonIntersection, getExtendCoord } from '../../themeRiverLayout/helper';

import { Rect, SeriesMaskConfig } from '../../type';
import WordCloudSeries from '../../WordCloudSeries';

type Point = [number, number];

export default function themeRiver(
  mask: SeriesMaskConfig,
  wordCloudSeries: WordCloudSeries,
  seriesModel: ThemeRiverSeriesModel,
  ecModel: GlobalModel,
  api: ExtensionAPI
): Point[] {
  const { name } = mask;
  const data = seriesModel.getData();
  // 获取河流图坐标系，判断方向
  const coordSys = seriesModel.coordinateSystem;
  const axis = coordSys.getAxis();
  const { orient } = axis;
  const isHor = orient === 'horizontal';

  // 获取轴线范围，截断河流图
  const coordRange = getExtendCoord(axis);
  const layoutInfo = data.getLayout('layoutInfo');
  const { rect, boundaryGap }: { rect: Rect; boundaryGap: number[] } = layoutInfo;

  // HACK：ECharts河流图本身只对Y轴做了处理, 如果河流图变为纵向的，可能会出现问题
  const yOffset = isHor ? rect.y + boundaryGap[0] : rect.y;
  const xOffset = isHor ? rect.x : rect.x + boundaryGap[0];

  const layerSeries = seriesModel.getLayerSeries();
  const targetLayer = layerSeries.find(layer => layer.name === name);
  if (!targetLayer) {
    return [];
  }

  const { indices = [] } = targetLayer;
  const seriesData = seriesModel.getData();

  // 根据索引获取itemLayout
  const itemLayouts = indices.map(index => seriesData.getItemLayout(index));

  // 按照主要轴线方向排序
  itemLayouts.sort((a, b) => a.x - b.x);

  /**
   * 根据itemLayout获取点集
   * @see https://github.com/apache/echarts/blob/b79777e9e48c97404ff4af0587e4b2e15f8b864a/src/chart/themeRiver/ThemeRiverView.ts#L92
   */

  const points = [];
  // eslint-disable-next-line thsjs/no-redundant-assignments
  for (let i = 0; i < itemLayouts.length; i += 1) {
    const item = itemLayouts[i];
    const { x, y0, y }: { x: number; y0: number; y: number } = item;
    points.push([x, y0 + yOffset]);
    points.unshift([x, y0 + y + yOffset]);
  }

  // 1.获取区间首尾的交点
  const [coordStart, coordEnd] = coordRange;
  const startIntersection = linePolygonIntersection(coordStart, points);
  const endIntersection = linePolygonIntersection(coordEnd, points);
  // 2.删除区间外的点
  const pointsFiltered = points.filter(d => {
    const dim = isHor ? 0 : 1;
    return d[dim] >= coordStart && d[dim] <= coordEnd;
  });
  // 3.填充交点到结果中
  if (startIntersection.length) {
    pointsFiltered.splice(pointsFiltered.length / 2 - 1, 0, ...startIntersection);
  }

  if (endIntersection.length) {
    pointsFiltered.push(endIntersection[1]);
    pointsFiltered.unshift(endIntersection[0]);
  }

  return points as Point[];
}
